
export default function PhilosophySection() {
  const values = [
    {
      icon: 'ri-heart-line',
      title: 'Comprometimento',
      description: 'fazemos acontecer.'
    },
    {
      icon: 'ri-eye-line',
      title: 'Transparência',
      description: 'comunicação clara em todas as etapas.'
    },
    {
      icon: 'ri-award-line',
      title: 'Excelência técnica',
      description: 'domínio das normas e processos.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Criatividade com propósito',
      description: 'beleza com viabilidade.'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-[#3F3F3F] mb-6">
            Nossa filosofia: técnica com alma.
          </h2>
          <div className="max-w-4xl mx-auto space-y-6 text-base text-[#3F3F3F] leading-relaxed">
            <p>
              A P&P nasceu com uma ideia simples: trazer humanidade à engenharia e precisão à arquitetura.
            </p>
            <p>
              Cada projeto é conduzido com o equilíbrio ideal entre razão e emoção — a razão que garante segurança e desempenho, e a emoção que dá vida e identidade aos espaços.
            </p>
            <p>
              Nosso time é formado por engenheiros, arquitetos e parceiros especializados que compartilham a mesma filosofia:
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div key={index} className="text-center group">
              <div className="w-16 h-16 mx-auto mb-4 bg-[#5C1A24] rounded-full flex items-center justify-center group-hover:bg-[#3F3F3F] transition-colors duration-300">
                <i className={`${value.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-semibold text-[#3F3F3F] mb-2">
                {value.title}
              </h3>
              <p className="text-sm text-[#3F3F3F]">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
